<template>
    <router-link tag="div" class="sidebar-link" :to="route" active-class="active-sidebar-link"
                 v-tooltip.right="broken ? `${caption} - THIS MODULE IS NOT CURRENTLY AVAILABLE` : caption"
                :event="broken ? '' : 'click'">
        <icon :icon="['fal', icon]" :style="{ color: broken ? '#ffe98e' : undefined }"/>
        <div class="badge" v-if="badge != undefined">{{badge}}</div>
    </router-link>
</template>

<script>
    export default {
        name: "SidebarLink",
        props: {
            icon: String,
            caption: String,
            route: String,
            badge: Number,
            broken: Boolean
        },
        data: function () {
            return {}
        }
    }
</script>

<style lang="scss">
    .sidebar-link {
      &:hover {
        animation: 0.5s ease hoverZoom;
        background-color: #FFFFFF15;
      }
        position: relative;
        cursor: pointer;
        padding: 15px;
        color: var(--input-active-font-color);
        font-size: 18px;
    }

    @keyframes hoverZoom {
      0% {
        background-color: #FFFFFF00;
      }

      100% {
        background-color: #FFFFFF15;
      }
    }

    .active-sidebar-link {
        border-left: 4px solid rgba(255, 255, 255, 0.75);
        background-color: rgba(255, 255, 255, 0.15);
    }

    .badge {
        user-select: none;
        background-color: var(--input-active-font-color);
        color: black;
        font-size: 9px;
        position: absolute;
        line-height: 9px;
        padding: 2px;
        border-radius: 5px;
        top: 33px;
        left: 27px;
        width: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

</style>